import { Alert, Box, Snackbar } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { PATHS } from './constants/routes';
import { GeneratorContentPage, GeneratorPage, BillingPage, TemplatesPage } from './components/pages';
import Dashboard from './components/layouts/Dashboard';
import AuthPage from './components/pages/AuthPage';
import { AUTH_CONFIG } from './constants/aws-config';
import Amplify from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './store/store';
import { hideAlert } from './store';
// import LogRocket from 'logrocket';
// import setupLogRocketReact from 'logrocket-react';
import { ProtectedRoute } from './components/ProtectedRoute';
import { InitApp } from './components/layouts/InitApp';
import { ElamaAuthPage } from './components/pages/ElamaAuthPage';
// LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY || '');
// setupLogRocketReact(LogRocket);

Amplify.configure(AUTH_CONFIG);

const App = () => {
  const { alert } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch<AppDispatch>();

  const handleHideAlert = () => {
    dispatch(hideAlert());
  };

  const routes = useRoutes([
    {
      element: <ProtectedRoute />,
      children: [
        {
          element: <InitApp />,
          children: [
            {
              path: PATHS.dashboard,
              element: <Dashboard />,
              children: [
                {
                  index: true,
                  element: <TemplatesPage />,
                },
                {
                  path: PATHS.generator,
                  element: <GeneratorPage />,
                  children: [
                    {
                      path: ':url',
                      element: <GeneratorContentPage />,
                    },
                  ],
                },
                {
                  path: PATHS.billing,
                  element: <BillingPage />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: PATHS.auth,
      element: <AuthPage />,
    },

    {
      path: PATHS.elamaSignin,
      element: <ElamaAuthPage />,
    },
  ]);

  return (
    <>
      <Box>{routes}</Box>
      {alert.message && (
        <Snackbar
          open={true}
          autoHideDuration={30000}
          onClose={handleHideAlert}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleHideAlert} severity={alert.type} sx={{ alignSelf: 'center' }}>
            {alert.message || ''}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default App;
